<template>
	<v-container>
		<p>
			The variable is scored on a scale from 0 to 100, with 0 indicating high levels of perceived corruption and 100 reflecting minimal corruption.  The map showcases the Corruption Perception Index (CPI) scores for 179 countries, offering insights into perceived corruption levels globally.
		</p>
		<p style="font-weight: bold;">Source: Transparency International (2018) – processed by Our World in Data.</p>
		<v-card>
			<iframe
				title="Human Rights in the World"
				aria-label="Map"
				id="datawrapper-chart-7f9NR"
				src="https://datawrapper.dwcdn.net/7f9NR/1/"
				scrolling="no"
				frameborder="0"
				style="width: 0; min-width: 100% !important; border: none;"
				height="441"
				data-external="1"
			>
			</iframe>
		</v-card>
	</v-container>
</template>

<script>
export default {
	mounted() {
		// Function to dynamically load external script
		const loadScript = (src, callback) => {
			const script = document.createElement("script")
			script.src = src
			script.onload = callback
			document.head.appendChild(script)
		}

		// Load the Datawrapper events script
		loadScript("https://static.dwcdn.net/js/events.js", () => {
			// Ensure the `datawrapper` object is available
			if (window.datawrapper) {
				window.datawrapper.on("region.click", (event) => {
					console.log(event.chartId, event.data)
				})
			}
		})

		// Handle iframe resizing
		const iframe = document.getElementById("datawrapper-chart-7f9NR")
		iframe.onload = () => {
			window.addEventListener("message", (event) => {
				if (event.data && event.data["datawrapper-height"]) {
					const iframes = document.querySelectorAll("iframe")
					for (const key in event.data["datawrapper-height"]) {
						for (let i = 0; i < iframes.length; i++) {
							if (iframes[i].contentWindow === event.source) {
								iframes[i].style.height =
									event.data["datawrapper-height"][key] + "px"
							}
						}
					}
				}
			})
		}
	},
}
</script>

<style scoped>
/* Add any custom styles here */
</style>
